const MAX_FILE_SIZE_MESSAGE = 'Maximum file size to upload is 2MB per file.'

export {
  MAX_FILE_SIZE_MESSAGE
}